import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import ResponsiveAppBar from '../components/ResponsiveAppBar'
import { isNotEmpty } from '../utils/helpers'
import AppRoutes from './AppRoutes'
import CookiesStorageService from './CookiesStorageService'

const PublicRoute = ({
  component: Component,
  path,
  guestOnly = false,
  withAppBar = true,
  appBarProps = { onlyLogo: true },
  ...props
}) => {
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const isAuthenticated = isNotEmpty(CookiesStorageService.getAccessToken())

  if (guestOnly && isAuthenticated) {
    return <Redirect to={baseUri + AppRoutes.landing} />
  }

  const resolvedAppBarProps = typeof appBarProps === 'function'
    ? appBarProps({ isAuthenticated })
    : appBarProps

  return (
    <Route
      path={path}
      render={(routeProps) => (
        <>
          {withAppBar && <ResponsiveAppBar {...resolvedAppBarProps} />}
          <Component {...routeProps} />
        </>
      )}
      {...props}
    />
  )
}

export default PublicRoute
